import React, { useState, useEffect, useRef } from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';
interface CollapsibleSectionProps {
    title: string;
    children: React.ReactNode;
    initialExpanded?: boolean;
    collapseOnContent?: boolean;
    isLoading?: boolean;
    maxHeight?: number;
}
export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
    title,
    children,
    initialExpanded = true,
    collapseOnContent = false,
    isLoading = false,
    maxHeight = 300
}) => {
    const [isExpanded, setIsExpanded] = useState(initialExpanded);
    const [hasBeenManuallyToggled, setHasBeenManuallyToggled] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!hasBeenManuallyToggled) {
            if (isLoading) {
                setIsExpanded(true);
            } else if (collapseOnContent && children) {
                setIsExpanded(false);
            }
        }
    }, [children, collapseOnContent, isLoading, hasBeenManuallyToggled]);

    useEffect(() => {
        if (contentRef.current) {
            contentRef.current.scrollTop = contentRef.current.scrollHeight;
        }
    }, [children]);
    return (
        <div className="mb-3 bg-neutral-50 dark:bg-neutral-900 rounded-md border border-neutral-200 dark:border-neutral-800">
            <div
                className="p-3 flex items-center cursor-pointer"
                onClick={() => {
                    setHasBeenManuallyToggled(true);
                    setIsExpanded(prev => !prev);
                }}
            >
                {isExpanded ? (
                    <FaChevronDown className="text-neutral-500 dark:text-neutral-400 mr-2" size={12} />
                ) : (
                    <FaChevronRight className="text-neutral-500 dark:text-neutral-400 mr-2" size={12} />
                )}
                <div className="text-xs uppercase tracking-wider text-neutral-500 dark:text-neutral-400">
                    {title}
                </div>
            </div>
            {isExpanded && (
                <div className="px-3 pb-3">
                    <div ref={contentRef} style={{ maxHeight: `${maxHeight}px` }} className="overflow-y-auto">
                        {children}
                    </div>
                </div>
            )}
        </div>
    );
};